import { initStepGating } from './shared.js';
import initSelect2 from '../helpers/select2.js';
import { addNewPrototype, getPrrcInfo, updateOptionsSelect2 } from '../helpers/helper.js';

const initChangeControlForm = () => {
	if(!$('#change-control-add-edit-container').length){
		return;
	}

	const affectsEl = $('#change_control_affects');
	const productSection = $('[data-change-control-products]');
	const processSection = $('[data-change-control-processes]');
	const supplierSection = $('[data-change-control-supplier-section]');
	const implementationDocumentsSelectionSection = $('[data-change-control-implementation-documents-selection]');
	const implementationDocumentsFreeTextSection = $('[data-change-control-implementation-documents-free-text]');
	const affectedSelect = $('#articles_affected').length
		? $('#articles_affected')
		: $('[name="articles_affected[]"]');
	const quantityAffected = $('#quantity_affected_items');

	const toggleGroup = (field, show) => {
		if(!field.length){
			return;
		}
		const isSection = field.is('[data-change-control-products], [data-change-control-processes], [data-change-control-supplier-section], [data-change-control-implementation-documents-selection], [data-change-control-implementation-documents-free-text]');
		const group = isSection || field.hasClass('form-group') ? field : field.closest('.form-group');
		if(show){
			group.removeClass('d-none');
		}else{
			group.addClass('d-none');
		}
	};

	const toggleAffects = () => {
		const value = affectsEl.val();
		const showProcess = value === 'internal_process';
		toggleGroup(productSection, value === 'article');
		toggleGroup(processSection, showProcess);
		toggleGroup(supplierSection, value === 'article');
		toggleGroup(implementationDocumentsSelectionSection, showProcess);
		toggleGroup(implementationDocumentsFreeTextSection, showProcess);
	};

	const getProductMeta = (select) => {
		if(!select || !select.length){
			return {};
		}
		const raw = select.attr('data-product-meta') || select.data('product-meta');
		if(!raw){
			return {};
		}
		if(typeof raw === 'object'){
			return raw;
		}
		try{
			return JSON.parse(raw);
		}catch(error){
			return {};
		}
	};

	const getSelectedProductIds = () => {
		const values = [];
		$('.change-control-product-select').each((index, element) => {
			const value = $(element).val();
			if(value){
				values.push(value);
			}
		});
		return values;
	};

	const getQuantityInputs = () => {
		return $('.change-control-product-select').map((index, element) => {
			const row = $(element).closest('.main-row');
			return row.find('input[name$="[quantity]"]').get(0);
		}).get().filter(Boolean);
	};

	let syncingQuantity = false;
	const syncQuantityAffected = (force = false) => {
		if(!quantityAffected.length){
			return;
		}
		if(!force && quantityAffected.data('manual')){
			return;
		}

		let sum = 0;
		let hasValue = false;

		getQuantityInputs().forEach((input) => {
			const raw = $(input).val();
			if(raw === null || raw === undefined || raw === ''){
				return;
			}
			const normalized = raw.toString().replace(',', '.');
			const value = parseFloat(normalized);
			if(Number.isNaN(value)){
				return;
			}
			hasValue = true;
			sum += value;
		});

		syncingQuantity = true;
		if(hasValue && sum > 0){
			quantityAffected.val(sum);
		}else{
			quantityAffected.val('');
		}
		syncingQuantity = false;
	};

	const syncSupplierFromProduct = (select) => {
		const productId = select.val();
		if(!productId){
			return;
		}
		const meta = getProductMeta(select);
		const supplierId = meta ? meta[productId] : null;
		if(!supplierId){
			return;
		}
		const supplierSelect = $('#supplier');
		if(!supplierSelect.length){
			return;
		}
		if(supplierSelect.val() != supplierId){
			supplierSelect.val(supplierId).trigger('change');
		}
	};

	const populateProductDetails = (select) => {
		const productId = select.val();
		if(!productId){
			return;
		}

		const row = select.closest('.main-row');
		const addressId = $('#address_id').val();

		if(!Number.isInteger(parseInt(addressId))){
			return;
		}
		if(!Number.isInteger(parseInt(productId))){
			return;
		}

		axios.get(`/api/product/${productId}/get-info-for-report?address_id=${addressId}`)
			.then((response) => {
				const data = response.data || {};
				if(!data || data === ''){
					return;
				}

				if(data.supplier_id){
					const supplierSelect = $('#supplier');
					if(supplierSelect.length){
						supplierSelect.val(data.supplier_id).trigger('change');
					}
				}

				const batchLots = [{id: '', text: "=== auswählen ==="}];
				if(data.batch_lots){
					Object.keys(data.batch_lots).forEach(batch_lot => batchLots.push({id: batch_lot, text: batch_lot}));
				}
				updateOptionsSelect2(row.find('[data-id="batch_lot"]'), batchLots);

				const serialNumbers = [{id: '', text: "=== auswählen ==="}];
				if(data.serial_numbers){
					Object.keys(data.serial_numbers).forEach(serial_number => serialNumbers.push({id: serial_number, text: serial_number}));
				}
				updateOptionsSelect2(row.find('[data-id="serial_number"]'), serialNumbers);
			});
	};

	let syncingAffected = false;
	const syncAffectedArticles = (force = false) => {
		if(!affectedSelect.length){
			return;
		}
		if(!force && affectedSelect.data('manual')){
			return;
		}
		const values = Array.from(new Set(getSelectedProductIds().filter(Boolean)));
		values.forEach((value) => {
			if(!affectedSelect.find(`option[value="${value}"]`).length){
				affectedSelect.append(new Option(value, value, true, true));
			}
		});
		syncingAffected = true;
		affectedSelect.val(values).trigger('change');
		syncingAffected = false;
	};

	const bindProductSelectEvents = () => {
		$(document).off('change.change-control-product select2:select.change-control-product select2:clear.change-control-product', '.change-control-product-select');
		$(document).on('change.change-control-product select2:select.change-control-product select2:clear.change-control-product', '.change-control-product-select', function () {
			const select = $(this);
			syncSupplierFromProduct(select);
			populateProductDetails(select);
			syncAffectedArticles();
			syncQuantityAffected();
		});
	};

	const bindQuantityEvents = () => {
		$(document).off('input.change-control-quantity change.change-control-quantity', 'input[name$="[quantity]"]');
		$(document).on('input.change-control-quantity change.change-control-quantity', 'input[name$="[quantity]"]', function () {
			syncQuantityAffected();
		});

		if(quantityAffected.length){
			quantityAffected.off('input.change-control-total change.change-control-total').on('input.change-control-total change.change-control-total', () => {
				if(!syncingQuantity){
					quantityAffected.data('manual', true);
				}
			});
		}
	};

	const initSupplierHandler = () => {
		const supplierSelect = $('[data-function="supplier-handler"]');
		if(!supplierSelect.length){
			return;
		}

		supplierSelect.unbind('change.change-control-supplier-handler').bind('change.change-control-supplier-handler', function(){
			$('[data-id="supplier_email"]').val('');
			$('[data-id="prrc_clinic_email"]').val('');
			$('[data-id="prrc_clinic_phone"]').val('');
			$('[data-id="supplier_ch_rep"]').val('');
			$('[data-id="supplier_ch_rep_number"]').val('');
			const linkedSupplierFields = $('[data-id="supplier_email"], [data-id="prrc_clinic_email"], [data-id="prrc_clinic_phone"], [data-id="supplier_ch_rep"], [data-id="supplier_ch_rep_number"]');
			linkedSupplierFields.prop('disabled', false);

			const value = $(this).val();
			if(value === null || value === undefined || !/^\d+$/.test(value.toString())){
				return;
			}

			getPrrcInfo(value, (data) => {
				if(data.id){
					$('[data-id="supplier_email"]').val(data.email_security);
					$('[data-id="prrc_clinic_email"]').val(data.important_contact_email);
					$('[data-id="prrc_clinic_phone"]').val(data.important_contact_phone);
					$('[data-id="supplier_ch_rep"]').val(data.ch_rep);
					$('[data-id="supplier_ch_rep_number"]').val(data.ch_rep_number);
				}
			});
		});
	};

	const initProductPrototype = () => {
		addNewPrototype('add-new-prototype-change-control-product', () => {
			initSelect2();
			bindProductSelectEvents();
			bindQuantityEvents();
			const newSelect = $('.change-control-product-select').last();
			if(newSelect.length){
				syncSupplierFromProduct(newSelect);
				populateProductDetails(newSelect);
			}
			syncAffectedArticles();
			syncQuantityAffected();
		}, () => {
			syncAffectedArticles();
			syncQuantityAffected();
		});
	};

	if(affectedSelect.length){
		affectedSelect.off('select2:select.change-control-affected select2:unselect.change-control-affected select2:clear.change-control-affected');
		affectedSelect.on('select2:select.change-control-affected select2:unselect.change-control-affected select2:clear.change-control-affected', () => {
			if(!syncingAffected){
				affectedSelect.data('manual', true);
			}
		});
	}

	if(affectsEl.length){
		affectsEl.unbind('change.change-control-affects').bind('change.change-control-affects', () => {
			toggleAffects();
			if(affectsEl.val() === 'article'){
				const select = $('.change-control-product-select').first();
				if(select.length){
					syncSupplierFromProduct(select);
				}
			}
		});
		toggleAffects();
	}
	bindProductSelectEvents();
	bindQuantityEvents();
	$('.change-control-product-select').each((index, element) => {
		const select = $(element);
		syncSupplierFromProduct(select);
		populateProductDetails(select);
	});
	if(!affectedSelect.val() || !affectedSelect.val().length){
		syncAffectedArticles(true);
	}
	if(!quantityAffected.val()){
		syncQuantityAffected(true);
	}
	initProductPrototype();
	initSupplierHandler();

	initStepGating({
		containerSelector: '[data-change-control-step]',
		messageSelector: '.change-control-step-message',
		disabledClass: 'change-control-step-disabled',
		eventNamespace: 'change-control-step'
	});
};

export default initChangeControlForm;
